import config from './asset/config'
import Asset from '@/models/Asset'
import Paginator from '@/models/Paginator'
import { findIndex } from 'lodash'
import { asset as backend } from '@/api'
import { common as pathLoader } from '@/api'

export default {

  namespaced: true,

  modules: { config },

  state: {
    asset: new Asset,
    assets: new Paginator,
    asset_list: [],
  },

  mutations: {
    setAssets: (state, payload) => state.assets = payload,
    setAssetList: (state, payload) => state.asset_list = payload,
    addAsset: (state, payload) => state.assets.data.push(payload),
    name: (state, payload) => state.asset.name = payload,
    configId: (state, payload) => state.asset.config_id = payload,
    moderate: (state) => state.asset.moderated = !state.asset.moderated,
    company: (state, payload) => state.asset.company_id = payload,
    setConfig: (state, configs) => {
      state.asset.configs = configs
    },
    updateConfigParam: (state, payload) => {
      let index = findIndex(state.asset.configs, config => config.param === payload.param)
      let config = state.asset.configs[index]
      config.value = payload.value 
      state.asset.configs.splice(index, 1, config)
    }
  },

  actions: {
    save: ({state, commit}) => new Promise((resolve, reject) => {
      backend.save(state.asset, response => {
        commit('addAsset', response.data)
        resolve()
      }, error => {
        reject(error)
      })
    }),
    loadAssetList: ({commit}, companyId) => new Promise((resolve, reject) => {
      backend.loadAssetList(companyId, response => {
        commit('setAssetList', response.data)
        resolve()
      }, error => {
        reject(error)
      })
    }),
    loadAssets: ({commit}, payload) => new Promise((resolve, reject) => {
      pathLoader.loadPath(payload, response => {
        commit('setAssets', response.data)
        resolve()
      }, error => {
        reject(error)
      })
    })
  },

  getters: {
    asset: state => state.asset,
    assets: state => state.assets,
    asset_list: state => state.asset_list,
  }

}